const imageContext = require.context("../img", true, /\.(jpe?g|png|webp|gif)$/i);

export function resolveImage(imageDir, file) {
  const key = `./${imageDir}/${file}`;
  try {
    const mod = imageContext(key);
    return mod.default ?? mod;
  } catch (error) {
    console.warn(`Missing image: ${key}`);
    return null;
  }
}

export function galleryFromJson({ imageDir, gallery }) {
  if (!gallery || gallery.length === 0) {
    return [];
  }

  return gallery
    .map(({ file, caption }) => {
      const img = resolveImage(imageDir, file);
      if (!img) {
        return null;
      }
      return { img, caption };
    })
    .filter(Boolean);
}

export function heroFromJson({ imageDir, heroImage }) {
  if (!heroImage) {
    return null;
  }
  return resolveImage(imageDir, heroImage);
}

export function animalGridFromJson({ imageDir, animals }) {
  if (!animals || animals.length === 0) {
    return [];
  }

  return animals.map(({ slug, name, gender, birthyear, traits, image }) => ({
    id: slug,
    name,
    gender,
    birthyear,
    traits,
    img: resolveImage(imageDir, image),
  }));
}
